import React, { useCallback, useState } from "react";
import { ProductionDuplicatesTab } from "./ProductionDuplicatesTab";
import { ProductionReportMismatchTab } from "./ProductionReportMismatchTab";

const SUB_MISMATCH = "mismatch";
const SUB_DUPLICATES = "duplicates";

export function ProductionAuditPanel() {
  const [subTab, setSubTab] = useState(SUB_MISMATCH);
  const [catalogRows, setCatalogRows] = useState(null);
  const [companyNames, setCompanyNames] = useState(new Map());

  const onCatalogLoaded = useCallback((rows) => {
    setCatalogRows(Array.isArray(rows) ? rows : null);
  }, []);

  const subClass = (tab) =>
    `tab-item${subTab === tab ? " active" : ""}`;

  return (
    <div className="production-audit-panel">
      <nav
        className="navigation-tabs admin-panel-tabs production-audit-subtabs"
        role="tablist"
        aria-label="Разделы аудита площадок"
      >
        <button
          type="button"
          role="tab"
          className={subClass(SUB_MISMATCH)}
          aria-selected={subTab === SUB_MISMATCH}
          onClick={() => setSubTab(SUB_MISMATCH)}
        >
          Расхождения с отчётом
        </button>
        <button
          type="button"
          role="tab"
          className={subClass(SUB_DUPLICATES)}
          aria-selected={subTab === SUB_DUPLICATES}
          onClick={() => setSubTab(SUB_DUPLICATES)}
        >
          Дубли между компаниями
        </button>
      </nav>

      {subTab === SUB_MISMATCH ? (
        <ProductionReportMismatchTab
          catalogRows={catalogRows}
          onCatalogLoaded={onCatalogLoaded}
          companyNames={companyNames}
          setCompanyNames={setCompanyNames}
        />
      ) : (
        <ProductionDuplicatesTab
          catalogRows={catalogRows}
          onCatalogLoaded={onCatalogLoaded}
          companyNames={companyNames}
        />
      )}
    </div>
  );
}
